import { AnalyticsMetaProvider } from '@cosuno/analytics-frontend';
import React from 'react';

import type { ANALYTICS_ENTRY_POINT } from '../entryPoints';

const AnalyticsEntryPoint: React.FC<
  React.PropsWithChildren<{ value: ANALYTICS_ENTRY_POINT | undefined }>
> = ({ value, children }) => (
  <AnalyticsMetaProvider entryPoint={value}>{children}</AnalyticsMetaProvider>
);

export default AnalyticsEntryPoint;
